
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 528.916 528.916","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M523.859 232.329h-41.701c-5.07 0-9.715-4.073-10.59-9.067-19.57-111.442-117-196.409-233.962-196.409C106.589 26.853 0 133.441 0 264.458c0 131.018 106.589 237.605 237.606 237.605 12.675 0 22.95-10.275 22.95-22.949s-10.275-22.949-22.95-22.949c-105.708 0-191.706-85.998-191.706-191.707 0-105.707 85.995-191.706 191.703-191.706 91.583 0 168.325 64.569 187.208 150.564 1.086 4.951-2.359 9.012-7.426 9.012H380.66c-5.07 0-6.578 3.182-3.371 7.108l69.162 84.621c3.209 3.926 8.408 3.926 11.619 0l69.162-84.621c3.207-3.925 1.696-7.107-3.373-7.107z"}})])
          )
        }
      }
    